<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="6">
          <p>连续签到天数</p>
          <div class="main" v-for="(item, index) in result" :key="index">
            <div class="left-box">
              <a-input v-model="item.signDay" style="width: 250px" />
            </div>
          </div>
        </a-col>
        <a-col :span="6">
          <p>获得积分</p>
          <div class="main" v-for="(item, index) in result" :key="index">
            <div class="left-box">
              <a-input v-model="item.signIntegral" style="width: 250px" />
            </div>
          </div>
        </a-col>
        <!-- <a-col :span="6">
          <p>获得积分</p>
          <a-input v-model="signIntegral" style="width: 250px" />
          <a-input style="width: 250px" />
          <a-input style="width: 250px" />
          <a-input style="width: 250px" />
          <a-input style="width: 250px" />
          <a-input style="width: 250px" />
          <a-input style="width: 250px" />
        </a-col> -->
      </a-row>
      <a-button class="a-button" @click="save">保存</a-button>
    </div>
  </div>
</template>

<script>
import { SigninRecord, SigninRecordEdit } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      result: [
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
        {
          signDay: "",
          signIntegral: "",
        },
      ],
      data: [],
      formInline: {
        user: "",
        password: "",
        store: "",
      },
    };
  },
  mounted() {
    this.getQianmignList();
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    getQianmignList() {
      SigninRecord().then((res) => {
        this.result = res.data;
        console.log(res);
      });
    },
    save() {
      console.log("sssssssss", this.result);
      SigninRecordEdit(this.result).then((res) => {
        message.success(res.data);
      });
    },
  },
};
</script>

<style scoped>
.left-box {
  float: left;
  margin-left: 20px;
}
.right-box {
  float: right;
}
.a-button {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/checkinConfiguration/checkinConfiguration.vue